<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { propertytypeService } from "../../../../services/propertyservice/propertytype.service";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Property Type List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      typeList: {},
      fetchingStats: false,
      title: "Type Templates List",

    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '?page=0') {
      this.fetchingStats = false;
      propertytypeService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.typeList = response;
        });
    },

    deleted: function(id) {
      propertytypeService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-property-type-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-property-type-add'}" :title="$t('setting.property.property-type.text')" />
    <List v-bind:dataList="typeList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ 
            `name: ${$t('setting.property.property-type.name')}`
          ]"
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-property-type-edit'}"
          v-bind:filter="{
            search: ['property_types.name'],
            dropdown: []
          }"
          
    />      
  </Layout>
</template>